export default __webpack_public_path__ + "static/media/bb-00007.c26f6f14.png";